import React from "react";
import Carousel from 'react-bootstrap/Carousel';

import roadmap0 from "../img/0_roadmap.png";
import roadmap1 from "../img/1_roadmap.png";
import roadmap2 from "../img/2_roadmap.jpg";
import roadmap3 from "../img/3_roadmap.png";
import roadmap4 from "../img/4_roadmap.png";


export default function BootstrapCarousel() {
  return (
    
    <Carousel >
      <Carousel.Item >
        <img
          className="d-block"
          style={{ height: 550, width: 850 }}
          src={roadmap0}
          alt="First slide"
        />
        <Carousel.Caption style={{ marginBottom: "4%", fontSize: "17px" }}>
          <h3>Esportare cultura e folklore italiano nel metaverso</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item >
        <img
          className="d-block"
          style={{ height: 550, width: 850 }}
          src={roadmap1}
          alt="Second slide"
        />

        <Carousel.Caption style={{ marginBottom: "4%", fontSize: "17px"}}>
          <h3>Creazione di una rete avente come partenza</h3>
          <h3>collezioni di nft dedicati alle maschere del carnevale italiano</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block"
          style={{ height: 550, width: 850 }}
          src={roadmap2}
          alt="Third slide"
        />

        <Carousel.Caption style={{ marginBottom: "4%", fontSize: "17px"}}>
          <h3>Colonizzazione dei metaversi di Somnium e The Sandbox</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block"
          style={{ height: 550, width: 850 }}
          src={roadmap3}
          alt="Fourth slide"
        />

        <Carousel.Caption style={{ marginBottom: "4%", fontSize: "17px"}}>
          <h3>Partenza del mercato congiunto fra</h3>
          <h3>prodotti digitali (nft) e prodotti reali (artigianato, produttori locali)</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block"
          style={{ height: 550, width: 850 }}
          src={roadmap4}
          alt="Third slide"
        />

        <Carousel.Caption style={{ marginBottom: "4%", fontSize: "17px"}}>
          <h3>Annuncio roadmap 2.0</h3>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
    
  );
}

